// https://developers.google.com/analytics/devguides/collection/gtagjs/pages

export const pageview = (url: string) => {
  if (!window.gtag) {
    return;
  }
  const GA_TRACKING_ID = window.ENV.GOOGLE_MEASUREMENT_ID;
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({
  action,
  category,
  label,
  value,
}: {
  action: string;
  category: string;
  label: string;
  value: any;
}) => {
  if (!window.gtag) {
    return;
  }
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
};
